import { styled } from "@mui/material";
import { COLORS } from "../../constants/colors";

export const CheckboxContainer = styled("div")`
  border: 1px solid ${COLORS.BORDER_CONTROL};
  border-radius: 4px;
  flex-grow: 1;
  padding-left: 1rem;
  display: flex;
  align-items: center;
  .MuiCheckbox-root {
    padding: 6px;
  }
  .MuiFormControlLabel-label {
    font-size: 0.9em;
  }
`;
